var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSatei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002455;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(325 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(-325 65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-320.387,95.571V91.516l4.228-2.812,4.972-5.159h12.924l3.65,5.159v7.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-294.613,96.582h-.008l-25.774-.261a.75.75,0,0,1-.742-.75V91.516a.75.75,0,0,1,.335-.625l4.16-2.767,4.915-5.1a.75.75,0,0,1,.54-.23h12.924a.75.75,0,0,1,.612.317l3.65,5.159a.75.75,0,0,1,.138.433v7.128a.75.75,0,0,1-.222.533A.75.75,0,0,1-294.613,96.582Zm-25.024-1.753,24.274.246V88.942l-3.288-4.647h-12.217l-4.75,4.929a.752.752,0,0,1-.125.1l-3.894,2.589Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-316.159,88.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(-316.104 92.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(-316.104 92.416)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(-303.738 92.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(-303.738 92.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-304.707,89.454h-11.452v-1.5h10.7V83.881h1.5V88.7A.75.75,0,0,1-304.707,89.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-294.613,89.454h-7.263a.75.75,0,0,1-.75-.75V83.881h1.5v4.073h6.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.25-.75a8,8,0,1,1-8,8A8.009,8.009,0,0,1,7.25-.75Zm0,14.5a6.5,6.5,0,1,0-6.5-6.5A6.507,6.507,0,0,0,7.25,13.75Z",
    transform: "translate(-312.75 66.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-305.5,74.183a.75.75,0,0,1-.542-.232l-2.9-3.036a.75.75,0,0,1,.024-1.06.75.75,0,0,1,1.06.024l2.357,2.468,2.357-2.468a.75.75,0,0,1,1.06-.024.75.75,0,0,1,.024,1.06l-2.9,3.036A.75.75,0,0,1-305.5,74.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,5.506a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V4.756A.75.75,0,0,1,0,5.506Z",
    transform: "translate(-305.5 73.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.449.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5.449A.75.75,0,0,1,6.2,0,.75.75,0,0,1,5.449.75Z",
    transform: "translate(-308.225 74.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.449.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5.449A.75.75,0,0,1,6.2,0,.75.75,0,0,1,5.449.75Z",
    transform: "translate(-308.225 76.911)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSatei);
export default __webpack_public_path__ + "static/media/icon_satei.f336329890a00433e064e80a2d4221a9.svg";
export { ForwardRef as ReactComponent };